import { Component } from '@angular/core';

@Component({
    selector: 'ez-public-footer',
    template: require('./public-footer.component.html'),
    styles: [require('./public-footer.component.less')]
})
export class PublicFooterComponent {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/public/public-footer.component.ts